"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addReservationEventsMutation = exports.sendReserveVehicleOrderMutation = exports.getNBFContractMutation = exports.saveOfferExpiryDateToOrderMutation = exports.updateMinimalOrderMutation = exports.prepareOrderForSubmissionMutation = exports.removeTradeInMutation = exports.saveTradeInMutation = exports.addChosenOfferMutation = exports.cancelOrderMutation = exports.resumeOrderMutation = exports.pauseOrderMutation = exports.removeCalculationFromOrderMutation = exports.addUserToOrderMutation = exports.createAndAddMarginToOrderMutation = exports.addMarginToOrderMutation = exports.addCalculationToOrderMutation = exports.saveInsuranceMutation = exports.addNewCalculationToOrderMutation = exports.updateOrderDiscountMutation = exports.updateOrderMutation = exports.signOrderMutation = exports.createMinimalOrderMutation = exports.orderConfirmedMinimalMutation = exports.orderConfirmedMutation = exports.sendOrderMutation = exports.createExistingOrderMutation = exports.createOrderMutation = void 0;
const types_1 = require("../../types");
const types_2 = require("../../types");
exports.createOrderMutation = `
  mutation createOrderMutation($input: OrderInput!) {
    createOrder(OrderInput: $input) {
      ...order
      ...nextError
    }
  }
  ${types_1.orderFragments}
  ${types_2.nextErrorFragment}
`;
exports.createExistingOrderMutation = `
  mutation createExistingOrder($id: String!, $input: OrderInput!) {
    createExistingOrder(id: $id, OrderInput: $input) {
      ...order
      __typename
    }
  }
  ${types_1.orderFragmentsWithBos}
`;
exports.sendOrderMutation = `
  mutation sendOrder($id: String!, $signedDate: String) {
    sendOrder(id: $id, signedDate: $signedDate) {
      id
      status
    }
  }
`;
exports.orderConfirmedMutation = `
  mutation orderConfirmedMutation($id: String!, $status: OrderStatus!, $statusMessage: String) {
    orderConfirmed(id: $id, status: $status, statusMessage: $statusMessage) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.orderConfirmedMinimalMutation = `
  mutation orderConfirmedMinimalMutation($id: String!, $status: OrderStatus!, $statusMessage: String, $serialNo: String) {
    orderConfirmed(id: $id, status: $status, statusMessage: $statusMessage, serialNo:$serialNo) {
      id
      status
      statusMessage
    }
  }
`;
exports.createMinimalOrderMutation = `
  mutation createMinimalOrderMutation($customerId: String!, $make: String, $modelSeries: String, $quoteId: String) {
    createMinimalOrder(customerId: $customerId, make: $make, modelSeries: $modelSeries, quoteId: $quoteId) {
      orderId
      orderURI
    }
  }
`;
exports.signOrderMutation = `
  mutation signOrderMutation($id: String!) {
    signOrder(id: $id) {
      ...order
      ...nextError
    }
  }
  ${types_1.orderFragments}
  ${types_2.nextErrorFragment}
`;
exports.updateOrderMutation = `
  mutation updateOrderMutation($id: String!, $input: OrderInput!) {
    updateOrder(id: $id, OrderInput: $input) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.updateOrderDiscountMutation = `
  mutation updateOrderDiscountMutation($id: String!, $discount: Float!) {
    updateOrderDiscount(id: $id, discount: $discount) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.addNewCalculationToOrderMutation = `
  mutation addNewCalculationToOrder($orderId: ID!, $input: CalculationInput!) {
    addNewCalculationToOrder(orderId: $orderId, input: $input) {
      ...order
      ...nextError
    }
  }
  ${types_1.orderFragments}
  ${types_2.nextErrorFragment}
`;
exports.saveInsuranceMutation = `
  mutation saveInsurance($orderId: ID!, $input: InsuranceInput!) {
    saveInsurance(orderId: $orderId, insurance: $input) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.addCalculationToOrderMutation = `
  mutation addCalculationToOrder($orderId: ID!, $calculationId: ID!) {
    addCalculationToOrder(orderId: $orderId, calculationId: $calculationId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.addMarginToOrderMutation = `
  mutation addMarginToOrder($orderId: ID!, $marginId: ID!) {
    addMarginToOrder(orderId: $orderId, marginId: $marginId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.createAndAddMarginToOrderMutation = `
  mutation createAndAddMarginToOrder($orderId: String!, $input: MarginInput!) {
    createAndAddMarginToOrder(orderId: $orderId, input: $input) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.addUserToOrderMutation = `
  mutation addUserToToOrder($orderId: ID!, $userId: ID!) {
    addUserToToOrder(orderId: $orderId, userId: $userId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.removeCalculationFromOrderMutation = `
  mutation removeCalculationFromOrder($orderId: ID!, $calculationId: ID!) {
    removeCalculationFromOrder(orderId: $orderId, calculationId: $calculationId) {
      ...order
      ...nextError
    }
  }
  ${types_1.orderFragments}
  ${types_2.nextErrorFragment}
`;
exports.pauseOrderMutation = `
  mutation pauseOrder($orderId: ID!) {
    pauseOrder(orderId: $orderId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.resumeOrderMutation = `
  mutation resumeOrder($orderId: ID!) {
    resumeOrder(orderId: $orderId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.cancelOrderMutation = `
  mutation cancelOrder($orderId: ID!) {
    cancelOrder(orderId: $orderId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.addChosenOfferMutation = `
  mutation addChosenOffer($orderId: ID!, $calculationId: ID!) {
    addChosenOffer(orderId: $orderId, calculationId: $calculationId) {
      ...order
      ...nextError
    }
  }
  ${types_1.orderFragments}
  ${types_2.nextErrorFragment}
`;
exports.saveTradeInMutation = `
  mutation saveTradeIn($orderId: ID!, $tradeIn: TradeInVehicleInput!) {
    saveTradeIn(orderId: $orderId, tradeIn: $tradeIn) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.removeTradeInMutation = `
  mutation removeTradeIn($orderId: ID!, $tradeInId: ID!) {
    removeTradeIn(orderId: $orderId, tradeInId: $tradeInId) {
      ...order
    }
  }
  ${types_1.orderFragments}
`;
exports.prepareOrderForSubmissionMutation = `
  mutation prepareOrderForSubmission($id: ID!) {
    prepareOrderForSubmission(id: $id) {
      ...order
    }
  }
  ${types_1.minimalOrderFragments}
`;
exports.updateMinimalOrderMutation = `
  mutation updateOrderMutation($id: String!, $input: OrderInput!) {
    updateOrder(id: $id, OrderInput: $input) {
      ...order
    }
  }
  ${types_1.minimalOrderFragments}
`;
exports.saveOfferExpiryDateToOrderMutation = `
  mutation updateOfferExpiryDateToOrder($id: ID!, $expiresAt: String!) {
    updateOfferExpiryDateToOrder(id: $id, expiresAt: $expiresAt) {
      id
      expiresAt
    }
  }
`;
exports.getNBFContractMutation = `
  mutation getNBFContractBeforeSigning($id: String!) {
    getNBFContractBeforeSigning(id: $id) {
      content
      displayName
    }
  }
  `;
exports.sendReserveVehicleOrderMutation = `
  mutation sendReserveVehicleOrder($id: String!, $status: VehicleReserveStatus!, $customerId: String!) {
    sendReserveVehicleOrder(id: $id, status: $status, customerId: $customerId) {
      ...order
    }
  }
  ${types_1.orderFragments}
  `;
exports.addReservationEventsMutation = `
  mutation addReservationEvents($id: String!, $serialNo: String!, $vehicleReserveStatus: VehicleReserveStatus!) {
    addReservationEvents(id: $id, serialNo: $serialNo, vehicleReserveStatus: $vehicleReserveStatus) {
      id
    }
  }
`;
//# sourceMappingURL=order.js.map